var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotAdm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_764_182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.5255 76H15.4746C11.8981 76 9 73.0134 9 69.3278V63.4816V51.7893V6.67224C9 2.98662 11.8981 0 15.4746 0H48.5255C52.1019 0 55 2.98662 55 6.67224V69.3278C55 73.0134 52.1019 76 48.5255 76ZM11.8365 66.4046V69.3278C11.8365 71.4248 13.5014 73.0769 15.4746 73.0769H48.5255C50.5604 73.0769 52.1636 71.4248 52.1636 69.3278V6.67224C52.1636 4.57525 50.5604 2.92308 48.5255 2.92308H15.4746C13.4397 2.92308 11.8365 4.6388 11.8365 6.67224V48.8662V66.4046Z",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 70H35",
    stroke: "#424242",
    strokeWidth: 1.66
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33 7.00043C33 7.55251 32.5525 8 31.9996 8C31.4475 8 31 7.55251 31 7.00043C31 6.44749 31.4475 6 31.9996 6C32.5525 6 33 6.44749 33 7.00043Z",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 66L49 65.9606V10H15V66Z",
    fill: "#FF8300"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 53V36.7568C36 28.0516 43.1605 21 52 21C60.8396 21 68 28.1003 68 36.7568C68 45.462 60.7901 52.5136 52 52.5136C47.8519 52.5136 43.9013 50.9089 40.889 48.1368L36 53Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 53V36.7568C36 28.0516 43.1605 21 52 21C60.8396 21 68 28.1003 68 36.7568C68 45.462 60.7901 52.5136 52 52.5136C47.8519 52.5136 43.9013 50.9089 40.889 48.1368L36 53ZM41.5719 44.8561L42.3201 45.6978C44.7985 48.4568 48.3058 50 52 50C59.1547 50 65 44.1547 65 37C65 29.7986 59.1547 24 52 24C44.7985 24 39 29.8453 39 37V47.428L41.5719 44.8561Z",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1268 25.0488C52.0796 25 51.9855 25 51.9384 25C51.8913 25.0488 51.8442 25.0976 51.8442 25.1464V26.8049C46.3804 26.8049 42 31.3902 42 37H44.3551C44.3551 32.7074 47.6992 29.2439 51.8442 29.2439V30.8537C51.8442 30.9024 51.8913 31 51.9384 31C51.9855 31.0488 52.0796 31 52.1268 30.9512L55 27.9756L52.1268 25.0488Z",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6449 37C59.6449 41.2753 56.3008 44.7247 52.1559 44.7247V43.1214C52.1559 43.0728 52.1087 42.9758 52.0616 42.9758C52.0145 42.9272 51.9204 42.9758 51.8732 43.0243L49 45.9879L51.8732 48.9514C51.9204 49 52.0145 49 52.0616 49C52.1087 48.9514 52.1559 48.9028 52.1559 48.8542V47.251C57.6196 47.251 62 42.6842 62 37.0972H59.6449V37Z",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 37C56 39.2381 54.1905 41 52 41C49.7619 41 48 39.1905 48 37C48 34.7619 49.8095 33 52 33C54.2381 33 56 34.7619 56 37Z",
    fill: "#FF8300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5909 39L50 37.3636L50.5909 36.8182L51.5909 37.8636L53.4546 36L54 36.591L51.5909 39Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_764_182"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76,
    height: 76,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotAdm);
export default __webpack_public_path__ + "static/media/notAdm.58ab3c5d985e5c22a40b68ebd06cc14a.svg";
export { ForwardRef as ReactComponent };